import { actionCreators, reducers } from './ducks';

export const headerSearchBar = {
    reducers,
    actionCreators,
};
